module.exports = __webpack_public_path__ + "media/promo/panasonic/images/machine-115a734f6c1aa9306cc10a126bc762bb.png";